/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UsedBy } from './used-by';
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Discount
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Discount
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    id: string;
    /**
     * Display name for the discount
     * @type {string}
     * @memberof Discount
     */
    name: string;
    /**
     * Optional description for internal use
     * @type {string}
     * @memberof Discount
     */
    description: string;
    /**
     * ITEM_DISCOUNT: Shows on products automatically. COUPON_CODE: Requires code at checkout
     * @type {string}
     * @memberof Discount
     */
    type: DiscountTypeEnum;
    /**
     * PERCENTAGE or FIXED_AMOUNT
     * @type {string}
     * @memberof Discount
     */
    valueType: DiscountValueTypeEnum;
    /**
     * The discount value (percentage 1-100 or fixed dollar amount)
     * @type {number}
     * @memberof Discount
     */
    value: number;
    /**
     * Maximum discount amount for percentage discounts (optional, mainly for COUPON_CODE)
     * @type {number}
     * @memberof Discount
     */
    cappedAt: number;
    /**
     * Coupon code (required for COUPON_CODE type)
     * @type {string}
     * @memberof Discount
     */
    code: string;
    /**
     * When the discount becomes active
     * @type {Date}
     * @memberof Discount
     */
    startsAt: Date;
    /**
     * When the discount expires
     * @type {Date}
     * @memberof Discount
     */
    expiresAt: Date;
    /**
     * Current lifecycle state
     * @type {string}
     * @memberof Discount
     */
    state: DiscountStateEnum;
    /**
     * Quick toggle to enable/disable the discount
     * @type {boolean}
     * @memberof Discount
     */
    isActive: boolean;
    /**
     * Products to apply discount to (all their variants will be discounted)
     * @type {Array<string>}
     * @memberof Discount
     */
    productsEligible: Array<string>;
    /**
     * Specific variants to apply discount to
     * @type {Array<string>}
     * @memberof Discount
     */
    variantsEligible: Array<string>;
    /**
     * Maximum total times this discount can be used (optional)
     * @type {number}
     * @memberof Discount
     */
    maxUses: number;
    /**
     * Maximum times a single user can use this discount (optional)
     * @type {number}
     * @memberof Discount
     */
    maxUsesPerUser: number;
    /**
     * Current total usage count
     * @type {number}
     * @memberof Discount
     */
    numberOfUses: number;
    /**
     * Usage history
     * @type {Array<UsedBy>}
     * @memberof Discount
     */
    usedBy: Array<UsedBy>;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    storeId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DiscountTypeEnum {
    ITEMDISCOUNT = 'ITEM_DISCOUNT',
    COUPONCODE = 'COUPON_CODE'
}
/**
    * @export
    * @enum {string}
    */
export enum DiscountValueTypeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXEDAMOUNT = 'FIXED_AMOUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum DiscountStateEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    EXPIRED = 'EXPIRED',
    SCHEDULED = 'SCHEDULED'
}

